/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Nie można pobrać obrazu',
    ERROR: 'Błąd'
  },
  HEADER: {
    DESCRIPTION: 'Opis',
    END_DATE: 'Do',
    ID: 'Id',
    START_DATE: 'Od',
    TITLE: 'Tytuł'
  },
  LABEL: {
    ACTIVES: 'Aktywne kampanie',
    CAMPAIGNS_SIGN_OR: 'Lub',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Kupon',
    DESCRIPTION: 'Opis',
    DESIGN_REQUESTS: 'Zamówienia dotyczące projektu',
    DESIGN_REQUESTS_ACTIVES: 'Aktywne zamówienia dotyczące projektów',
    DESIGN_REQUESTS_TERMINATED: 'Zakończone zamówienia projektowe',
    DETAIL: 'Szczegóły',
    END_DATE: 'Do',
    FILES_TITLE: 'Zasoby kampanii',
    FILES_TITLE_DESIGN_REQUEST: 'Zasoby dotyczące wniosku o rejestrację wzoru',
    FINISHED: 'Zakończony',
    FINISHED_DESIGN_REQUEST: 'Zakończone',
    GENERATED: 'Utworzony',
    GENERIC_DESIGN: 'Ogólny projekt',
    ID: 'Id',
    IN_PROGRESS: 'W toku',
    NO_ROWS_CAMPAIGNS: 'Brak kampanii',
    NO_ROWS_DESIGN_REQUESTS: 'Brak zamówień na projekty',
    OFFER: 'Oferta',
    PREVIOUS_LEVEL: 'Poprzedni poziom',
    START_DATE: 'Od',
    STATUS: 'Stan',
    TERMINATED: 'Zakończone kampanie',
    TITLE: 'Tytuł',
    VALUE: 'Wartość'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION: 'Brak załączników dla tej kampanii (jeszcze).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Brak załączników do tego wniosku o projekt (na razie).',
    ATTACHMENT_TITLE: 'Brak załączników'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
